import { ExtractKeys } from './utility-types';

interface Options {
  numeric: boolean;
}

export const chunkArray = <T>(items: T[], chunkSize: number) =>
  items.reduce<T[][]>((chunks, item, index) => {
    const chunkIndex = Math.floor(index / chunkSize);
    if (!chunks[chunkIndex]) {
      chunks[chunkIndex] = [];
    }
    chunks[chunkIndex].push(item);
    return chunks;
  }, []);

export const localeCompare =
  <T extends Record<string, any>>(
    key: ExtractKeys<T, string>,
    options?: Options,
  ) =>
  (a: T, b: T) => {
    return a[key].localeCompare(b[key], 'en', options);
  };

export function sum(a: number, b: number): number {
  return a + b;
}
